<template>
	<div class="page-container">
		<head-top head-title="注册" goBack="true"></head-top>

		<div class="register-page">
			<div class="register-title">注册账号</div>
			<div class="register-desc">邮箱验证码用于确认账号归属</div>

			<div class="register-body">
				<div class="input-group">
					<input class="input-field" name="account" v-model="form.account" placeholder="请输入邮箱账号" type="text" />
				</div>
				<div class="input-group">
					<input class="input-field" name="password" v-model="form.pwd" type="password" placeholder="请设置密码，至少6位" />
				</div>
				<div class="input-group">
					<input class="input-field" name="confirmPwd" v-model="confirmPwd" type="password" placeholder="请再次输入密码" />
				</div>
				<div class="input-group flex_a">
					<input class="input-field captcha-input" name="emailCode" v-model="form.emailCode" placeholder="请输入邮箱验证码" type="number" maxlength="6" />
					<div class="code-btn" :class="{ disabled: countdown > 0 }" @click="sendCode">
						{{ countdown > 0 ? countdown + 's' : '获取验证码' }}
					</div>
				</div>

				<button class="register-btn" @click="handleRegister">注册</button>

				<div class="register-footer">
					<span>已有账号？</span>
					<span class="login-link" @click="goLogin">立即登录</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		registerMember,
		sendEmailCode
	} from '@/apis/api.js'

	export default {
		name: 'Register',
		components: {
			headTop: headTop
		},
		data() {
			return {
				form: {
					account: '',
					pwd: '',
					emailCode: ''
				},
				confirmPwd: '',
				countdown: 0,
				timer: null
			}
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		methods: {
			isEmail(email) {
				return /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(email)
			},
			sendCode() {
				if (!this.isEmail(this.form.account)) {
					this.$toast('请输入正确邮箱')
					return
				}
				if (this.countdown > 0) return

				this.$toast.loading({ message: '发送中...', duration: 0 })
				sendEmailCode(this.form.account)
					.then(() => {
						this.$toast.success('验证码已发送')
						this.countdown = 60
						clearInterval(this.timer)
						this.timer = setInterval(() => {
							this.countdown -= 1
							if (this.countdown <= 0) {
								clearInterval(this.timer)
							}
						}, 1000)
					})
					.catch(e => {
						if (e.handled) return
						this.$toast(e.msg || '发送失败')
					})
					.finally(() => {
						this.$toast.clear()
					})
			},
			handleRegister() {
				if (!this.isEmail(this.form.account)) {
					this.$toast('请输入正确邮箱')
					return
				}
				if (!this.form.pwd || this.form.pwd.length < 6) {
					this.$toast('密码至少6位')
					return
				}
				if (this.form.pwd !== this.confirmPwd) {
					this.$toast('两次密码不一致')
					return
				}
				if (!this.form.emailCode) {
					this.$toast('请输入邮箱验证码')
					return
				}

				this.$toast.loading({ message: '注册中...', duration: 0 })
				registerMember(this.form)
					.then(() => {
						this.$toast.success('注册成功')
						setTimeout(() => {
							this.$router.replace('/login')
						}, 500)
					})
					.catch(e => {
						if (e.handled) return
						this.$toast(e.msg || '注册失败')
					})
					.finally(() => {
						this.$toast.clear()
					})
			},
			goLogin() {
				this.$router.replace('/login')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.register-page {
			padding: 50px 28px 0;

			.register-title {
				color: #222222;
				font-size: 24px;
				font-weight: bold;
			}

			.register-desc {
				margin-top: 10px;
				color: #888888;
				font-size: 14px;
			}

			.register-body {
				margin-top: 55px;

				.input-group {
					height: 46px;
					margin-bottom: 14px;
					border-bottom: 1px solid #e4e7ed;
					box-sizing: border-box;

					.input-field {
						width: 100%;
						height: 46px;
						line-height: 46px;
						color: #222222;
						font-size: 15px;

						&::placeholder {
							color: #999;
						}
					}

					.captcha-input {
						flex: 1 !important;
						width:auto !important;
					}

					.code-btn {
						flex:none;
						color:#f9e1ae;
						width: 95px;
						height: 36px;
						line-height: 36px;
						text-align: center;
						font-size: 13px;
						border-radius: 18px;
						background: #222;
						cursor: pointer;

						&.disabled {
							background: #cccccc;
							color: #666666;
							cursor: not-allowed;
						}
					}
				}

				.register-btn {
					height: 44px;
					line-height: 44px;
					margin-top: 20px;
					color: #ffffff;
					background: #E6A23C;
					border-radius: 22px;
					font-size: 17px;
					font-weight: bold;
					width: 100%;
				}

				.register-footer {
					margin-top: 20px;
					text-align: right;
					color: #999999;
					font-size: 13px;

					.login-link {
						margin-left: 8px;
						color: #E6A23C;
						font-weight: bold;
					}
				}
			}
		}
	}
</style>
